import * as React from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import { TextareaItem } from 'antd-mobile'
import styles from './index.module.scss'

interface IFormItemProps {
  setValue?: (value: string) => void
  className?: string
  classNameCount?: string
  maxLimit?: number
  minLimit?: number
  showCount?: boolean
}

const FormItemDescription: React.FC<IFormItemProps & ControllerRenderProps> = ({
  className,
  maxLimit = 300,
  minLimit = 0,
  showCount,
  value,
  ...rest
}) => {
  return (
    <section
      className={`${styles['form-textarea']} ${
        showCount ? styles['show-count'] : ''
      } ${className}`}
    >
      <TextareaItem {...rest} value={value} rows={4} />
      {showCount && (
        <div className='count'>
          <span
            className={`${
              value?.length > maxLimit || value?.length < minLimit ? 'red' : ''
            }`}
          >
            {value?.length || 0}
          </span>
          /<span>{maxLimit}</span>
        </div>
      )}
    </section>
  )
}

export default FormItemDescription
